import React from 'react';
import { motion } from 'framer-motion';
import { FaHeart } from 'react-icons/fa';

const LoadingSpinner = () => {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'var(--dark)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 30, zIndex: 9999,
    }}>
      <div style={{ position: 'relative', width: 80, height: 80 }}>
        {[0, 1, 2].map(i => (
          <motion.div key={i}
            animate={{ rotate: 360 }}
            transition={{ duration: 1.5 + i * 0.3, repeat: Infinity, ease: 'linear' }}
            style={{
              position: 'absolute', inset: i * 8,
              border: `3px solid transparent`,
              borderTopColor: i === 0 ? 'var(--primary)' : i === 1 ? 'var(--accent)' : 'var(--secondary)',
              borderRadius: '50%',
            }}
          />
        ))}
        <div style={{
          position: 'absolute', inset: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <motion.div animate={{ scale: [1, 1.2, 1] }} transition={{ duration: 1.5, repeat: Infinity }}>
            <FaHeart size={20} style={{ color: 'var(--primary)' }} />
          </motion.div>
        </div>
      </div>
      <motion.p
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        style={{ color: 'var(--gray-light)', fontFamily: 'Space Grotesk', fontWeight: 500 }}
      >
        Loading MaaCompanion...
      </motion.p>
    </div>
  );
};

export default LoadingSpinner;